import { useAppSelector } from 'app/hooks';
import { useMemo } from 'react';
import { selectActivePtacConfiguration } from 'utils/active-ptac-configuration';
import { isPtacDesignReady } from 'utils/configuration-eligibility';
import { summarizePtacSystems } from 'utils/ptac-systems-summary';
import { PtacDesignSystemsSummary } from 'utils/ptac-systems-summary-types';

export default function usePtacDesignSystemsSummary(): PtacDesignSystemsSummary {
  const configuration = useAppSelector(selectActivePtacConfiguration);
  const status = useAppSelector((state) => state.ptacSelection.systems.status);
  const options = useAppSelector(
    (state) => state.ptacSelection.systems.options
  );
  const ready = isPtacDesignReady(configuration);
  const summary = useMemo(
    () => (ready && status === 'loaded' ? summarizePtacSystems(options) : null),
    [ready, status, options]
  );
  return { ready, isLoading: ready && status === 'loading', summary };
}
